﻿<script setup lang="ts">
    import { ref } from 'vue';

    const props = defineProps<{
        id: string;
    }>();

    const iframeEl = ref<HTMLIFrameElement | null>(null);
    const show = ref<boolean>(true);

    const getIframeHeight = () => {
        const el: HTMLIFrameElement = iframeEl.value!;
        el.contentWindow!.postMessage({ getIframeHeight: { iframeId: el.getAttribute('id') } }, el.src);
    };
</script>

<script lang="ts">
    window.addEventListener('message', (event) => {
        if (!event.data.iframeHeight || !event.data.iframeId) return;
        const el = document.getElementById(event.data.iframeId);
        el && (el.style.height = event.data.iframeHeight + 'px');
    });
</script>

<template>
    <div class="popover-survey" v-show="show">
        <iframe
            ref="iframeEl"
            :id="'survey-' + props.id"
            :src="'https://ui.ungpd.com/Surveys/' + props.id"
            loading="lazy"
            scrolling="no"
            @load="getIframeHeight"></iframe>

        <button type="button" class="btn btn-default round p-absolute" @click="() => (show = !show)">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">{{ $Resources.CloseModalButton }}</span>
        </button>
    </div>
</template>

<style scoped></style>

<style></style>
